import { Controller } from '../utils/controller';

// Create increment/decrement number input spinners

const DEFAULT_QUANTITY = 1;
export default class NumberIncrementer extends Controller {
  static targets = ['activeValue', 'decrease', 'increase'];
  static requiredTargets = [];
  static classes = ['inActive'];
  static requiredClasses = [];
  static values = {
    active: Number,
    initial: {
      type: Number,
      default: 0
    },
    maximum: Number,
    minimum: {
      type: Number,
      default: 0
    }
  };

  // TARGETS
  declare activeValueTargets: HTMLDivElement[];
  declare decreaseTargets: HTMLButtonElement[];
  declare increaseTargets: HTMLButtonElement[];
  declare readonly hasActiveValueTarget: boolean;
  declare readonly hasDecreaseTarget: boolean;
  declare readonly hasIncreaseTarget: boolean;

  // CLASSES
  declare hasInActiveClass: string;
  declare inActiveClasses: string[];

  // VALUES
  declare activeValue: number;
  declare initialValue: number;
  declare minimumValue: number;
  declare maximumValue: number;

  activeValueChanged() {
    this.dispatch('changed', { detail: { value: this.activeValue } });
    this.render();
  }

  getInitialValue() {
    if (this.initialValue < this.minimumValue) {
      return this.minimumValue;
    }
    if (this.initialValue > this.maximumValue) {
      return this.maximumValue;
    }
    return this.initialValue;
  }

  getQuantityParam(event) {
    return event?.params?.quantity || DEFAULT_QUANTITY;
  }

  decrement(event) {
    const value = this.activeValue - this.getQuantityParam(event);
    this.activeValue = value < this.minimumValue ? this.minimumValue : value;
  }

  increment(event) {
    const value = this.activeValue + this.getQuantityParam(event);
    this.activeValue = value > this.maximumValue ? this.maximumValue : value;
  }

  initialize() {
    this.activeValue = this.getInitialValue();
  }

  render() {
    if (this.activeValue == 0) {
      this.initialize();
    }

    this.renderActiveValue();
    if (this.hasInActiveClass) {
      this.renderControlElementStatus();
    }
  }

  renderActiveValue() {
    if (this.hasActiveValueTarget) {
      this.activeValueTargets.forEach((target) => {
        this.setHTMLElementValue(target, this.activeValue);
      });
    }
  }

  renderControlElementStatus() {
    if (this.hasDecreaseTarget) {
      this.decreaseTargets.forEach((target) => {
        this.toggleElementClasses(
          target,
          this.inActiveClasses,
          this.activeValue === this.minimumValue
        );
      });
    }

    if (this.hasIncreaseTarget) {
      this.increaseTargets.forEach((target) => {
        this.toggleElementClasses(
          target,
          this.inActiveClasses,
          this.activeValue === this.maximumValue
        );
      });
    }
  }

  setHTMLElementValue(element, value) {
    element[element instanceof HTMLInputElement ? 'value' : 'innerHTML'] = value;
  }

  toggleElementClasses(element, classesArray, isClassAdded) {
    element.classList[isClassAdded === true ? 'add' : 'remove'](...classesArray);
  }
}
